import styled, { keyframes, css } from 'styled-components';
import { Notification } from '../Notification';
var progress = keyframes(["from{stroke-dashoffset:-82px;}to{stroke-dashoffset:-164px;}"]);
export var SVGContainer = styled.svg.withConfig({
  displayName: "components__SVGContainer",
  componentId: "sc-19b1rha-0"
})(["overflow:visible;position:absolute;transform:rotate(-90deg);"]);
export var IndicatorCircle = styled.circle.withConfig({
  displayName: "components__IndicatorCircle",
  componentId: "sc-19b1rha-1"
})(["fill:transparent;stroke-dasharray:82px;stroke-width:1px;stroke:currentColor;opacity:0.4;stroke-dashoffset:0;transition:stroke 0.2s ease-in-out;", ":hover &{opacity:1;}", ":active &{fill:rgb(255,255,255,0.1);}"], SVGContainer, SVGContainer);
export var ProgressCircle = styled.circle.withConfig({
  displayName: "components__ProgressCircle",
  componentId: "sc-19b1rha-2"
})(function (_ref) {
  var dismissIn = _ref.dismissIn;
  return css(["fill:transparent;stroke-dasharray:82px;stroke-width:1px;animation-delay:0.5s;animation-name:", ";animation-timing-function:linear;animation-fill-mode:forwards;animation-duration:", "ms;stroke:currentColor;stroke-dashoffset:", ";stroke-linecap:round;"], progress, dismissIn, dismissIn === 0 ? '-164px' : '-82px');
});
export var ToastRoot = styled(Notification.Root).withConfig({
  displayName: "components__ToastRoot",
  componentId: "sc-19b1rha-3"
})(function (_ref2) {
  var theme = _ref2.theme,
      takeContainerWidth = _ref2.takeContainerWidth;
  return css(["border:1px solid ", "04;box-shadow:", ";border-radius:", ";margin-bottom:", "px;max-width:", ";min-height:40px;padding:", "px ", "px;width:", ";"], theme.colors.base.black, theme.shadows[5], theme.radii[8], theme.space[2], takeContainerWidth ? 'auto' : 'calc(100vw - 24px * 2)', theme.space[2], theme.space[4], takeContainerWidth ? '100%' : '344px');
});